import { graphql } from 'react-relay';
import { useEffect, useState } from 'react';
import { usePageSpaceKey } from '@confluence/page-context';

import type {
	useIsSpaceOrSiteAdminSpaceAdminQuery as useIsSpaceOrSiteAdminSpaceAdminQuery$data,
	useIsSpaceOrSiteAdminSpaceAdminQueryVariables as useIsSpaceOrSiteAdminSpaceAdminQuery$variables,
} from './__types__/useIsSpaceOrSiteAdminSpaceAdminQuery.ts';
import { useSPAViewContext } from './content-ownership-helpers.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useIsSpaceOrSiteAdmin = (): boolean => {
	const [spaceKey] = usePageSpaceKey();
	const { isSiteAdmin } = useSPAViewContext();
	const [isSpaceAdmin, setIsSpaceAdmin] = useState<boolean>(false);
	const { data } = useQueryInterop<
		useIsSpaceOrSiteAdminSpaceAdminQuery$data,
		useIsSpaceOrSiteAdminSpaceAdminQuery$variables
	>(
		graphql`
			query useIsSpaceOrSiteAdminSpaceAdminQuery($spaceKey: String!) {
				space(key: $spaceKey) {
					id
					currentUser {
						isAdmin
					}
				}
			}
		`,
		{
			variables: {
				spaceKey: spaceKey!,
			},
			skip: !spaceKey,
		},
	);

	useEffect(() => {
		const isAdmin = data?.space?.currentUser?.isAdmin ?? false;
		setIsSpaceAdmin(isAdmin);
	}, [data]);

	return isSiteAdmin || isSpaceAdmin;
};
